'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { useAsset } from '@marketplace-web/shared/assets'

import Block from './Block'
import Content from './Content'

const Convincing = () => {
  const translate = useTranslate('business.homepage')
  const { user } = useSession()
  const isUserLoggedIn = !!user
  const asset = useAsset('/assets/business-accounts')

  const convincingHeading: string = translate(
    isUserLoggedIn ? 'how_different.title' : 'why_vinted_pro.title',
  )

  function getImageSrc(src: string) {
    return asset(`${src}.jpg`, { theme: { dark: `${src}_dark.jpg` } })
  }

  const convincingBlocks: Array<React.ComponentProps<typeof Block>> = isUserLoggedIn
    ? [
        {
          imageSrc: getImageSrc('why-pro-5'),
          title: translate('how_different.high_volume_sales.title'),
          body: translate('how_different.high_volume_sales.body'),
        },
        {
          imageSrc: getImageSrc('why-pro-4'),
          title: translate('how_different.clarity_for_buyers.title'),
          body: translate('how_different.clarity_for_buyers.body'),
        },
        {
          imageSrc: getImageSrc('why-pro-2'),
          title: translate('how_different.return_policy.title'),
          body: translate('how_different.return_policy.body'),
        },
      ]
    : [
        {
          imageSrc: getImageSrc('why-pro-1'),
          title: translate('why_vinted_pro.unlimited_sales.title'),
          body: translate('why_vinted_pro.unlimited_sales.body'),
        },
        {
          imageSrc: getImageSrc('why-pro-2'),
          title: translate('why_vinted_pro.potential_buyers.title'),
          body: translate('why_vinted_pro.potential_buyers.body'),
        },
        {
          imageSrc: getImageSrc('why-pro-3'),
          title: translate('why_vinted_pro.best_of_vinted.title'),
          body: translate('why_vinted_pro.best_of_vinted.body'),
        },
      ]

  return (
    <div className="content-block">
      <div className="content-block__content u-ui-padding-bottom-x4-large@desktops u-ui-padding-bottom-x-large@portables">
        <div className="u-clearfix">
          <Content heading={convincingHeading} blocks={convincingBlocks} />
        </div>
      </div>
    </div>
  )
}

export default Convincing
